function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "12",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#39C696",
  cx: "6",
  cy: "6",
  r: "6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.648 3.645a.5.5 0 01.762.642l-.058.068-4.044 4a.5.5 0 01-.635.057l-.069-.057L2.648 6.41a.5.5 0 01.635-.767l.07.058 1.603 1.594 3.692-3.65z",
  fill: "#FFF"
}))));